<template>
  <v-card>
    <v-form>
      <div class="grey--text ml-2 mt-3 overline primary--text">
        Question
        <v-btn
          small
          class="ml-5 d-inline"
          icon
          @click="localCard.question = $store.state.lastEditQuestion"
          >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
        <v-btn
          small
          class="ml-5 d-inline"
          icon
          @click="localCard.question = clearStyles(localCard.question)"
          >
          <v-icon>mdi-format-clear</v-icon>
        </v-btn>
      </div>

      <vue-editor id="editor1" v-model="localCard.question" :editorToolbar="customToolbar"></vue-editor>
      <imageUpload ref="questionImage" :existingCard="localCard.question_image" @downloadURL="questionImageUpload"/>
      <div class="grey--text ml-2 mt-3 overline primary--text">
        Answer
        <v-btn
          small
          class="ml-5 d-inline"
          icon
          @click="localCard.answer = $store.state.lastEditAnswer"
          >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
        <v-btn
          small
          class="ml-5 d-inline"
          icon
          @click="localCard.answer = clearStyles(localCard.answer)"
          >
          <v-icon>mdi-format-clear</v-icon>
        </v-btn>
      </div>
      <vue-editor id="editor2" v-model="localCard.answer" :editorToolbar="customToolbar"></vue-editor>
      <imageUpload ref="answerImage" :existingCard="localCard.answer_image" @downloadURL="answerImageUpload"/>
      <div class="grey--text ml-2 mt-3 overline primary--text">
        Learn More
        <v-btn
          small
          class="ml-5 d-inline"
          icon
          @click="localCard.learnMore = clearStyles(localCard.learnMore)"
          >
          <v-icon>mdi-format-clear</v-icon>
        </v-btn>
      </div>
      <vue-editor id="editor3" v-model="localCard.learnMore" :editorToolbar="customToolbar"></vue-editor>
      <imageUpload ref="learnMoreImage" :existingCard="localCard.learnMore_image" @downloadURL="learnMoreImageUpload"/>


    </v-form>
    <v-btn absolute right class="ma-3" color="orange" dark v-if="!card" @click="saveCard">Save Card</v-btn>
    <v-btn absolute right class="ma-3" color="blue" dark v-if="card" @click="editCard">Edit Card</v-btn>
  </v-card>

</template>

<script>
import firebase from 'firebase'
var firestorage = firebase.storage();
import uuid from 'uuid/v4'
import imageUpload from '@/components/imageUpload'
import { VueEditor } from "vue2-editor";
import obj from '@/objects'

export default {
  name: 'CardTypeQA',
  props: ['card'],
  components: {
    imageUpload,
    VueEditor
  },
  watch: {
    card() {
      this.setCard()
    }
  },
  data() {
    return {
      customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
      localCard: null,

    }
  },
  created() {
    this.setCard()
  },
  methods: {
    questionImageUpload(url) {
      this.localCard.question_image = url
    },
    answerImageUpload(url) {
      this.localCard.answer_image = url
    },
    learnMoreImageUpload(url) {
      this.localCard.learnMore_image = url
    },
    setCard() {
      if (this.card != null) {
        this.localCard = this.card
      }
      else {
        this.localCard = obj.createNewCard('question_answer')
        this.resetImageUpload()
      }

    },
    processAllImages() {
      return Promise.all([
        this.processImages(this.localCard.question),
        this.processImages(this.localCard.answer),
        this.processImages(this.localCard.learnMore)
      ]).then((result) => {
        console.log(result)
        this.localCard.question = result[0]
        this.localCard.answer = result[1]
        this.localCard.learnMore = result[2]
      })
    },
    processImages(field) {
      const regexp = /(data:image\/[^;]+;base64[^"]+)/g
      const ar = [...field.matchAll(regexp)];
      let promises = []
      ar.forEach(item => {
        let string = item[0]
        promises.push(
          firestorage.ref('inline/' + uuid()).putString(string, 'data_url', {contentType:'image/png'})
        )
      })
      return Promise.all(promises).then(result => {
        let promises = []
        result.forEach(p => {
          promises.push(p.ref.getDownloadURL())

        })
        return Promise.all(promises)
      }).then(result => {

        result.forEach((item, index) => {
          field = field.replace(ar[index][0], item)
        })
        return field
      })
    },
    saveCard() {
      this.processAllImages().then(() => {

        this.$emit('saveCard', this.localCard)

        //save last edit for quick access for next question
        this.$store.commit("lastEditQuestionSet", this.localCard.question)
        this.$store.commit("lastEditAnswerSet", this.localCard.answer)

        this.localCard = obj.createNewCard('question_answer')
        this.resetImageUpload()
      })
    },
    editCard() {
      this.processAllImages().then(() => {
        this.$emit('editCard', this.localCard)

        //save last edit for quick access for next question
        this.$store.commit("lastEditQuestionSet", this.localCard.question)
        this.$store.commit("lastEditAnswerSet", this.localCard.answer)

        this.localCard = obj.createNewCard('question_answer')
        this.resetImageUpload()
      })
    },
    resetImageUpload() {
      this.$refs.answerImage.resetComponent()
      this.$refs.questionImage.resetComponent()
      this.$refs.learnMoreImage.resetComponent()
    },
    clearStyles(str) {
      console.log(str)
      let result = str.replace(/style="[^"]*"/, "")
      result = result.replace(/<p><br><\/p>/g,"")
      console.log(result)
      return result
    }
  }
}
</script>

<style>
#editor1 {
  height: 200px;
}
#editor2 {
  height: 200px;
}
ol {
  margin-bottom: 1.0em;
}
ul {
  margin-bottom: 1.0em;
}
.flex p {
  margin-bottom: 0.5em !important;
}
.ql-indent-1 {
  margin-left: 1em;
}
.ql-indent-2 {
  margin-left: 2em;
}
.ql-indent-3 {
  margin-left: 3em;
}
.ql-indent-4 {
  margin-left: 4em;
}
</style>
